import type {Integer, ValueByDevice} from 'platform/foundation';

import type {ChartCardWidth} from '../types/ChartCardWidth';

/**
 * Summary card columns by the width of the chart card. Summary cards keep one width on desktop,
 * so a row of fewer cards leaves the rest empty. A half-width chart card is half width on desktop
 * only, so it shows 2 summary cards per row there and the full-width columns elsewhere.
 */
export const CHART_SUMMARY_COLUMNS: Record<ChartCardWidth, ValueByDevice<Integer>> = {
  full: [1, 2, 4],
  half: [1, 2, 4, 2],
};
